import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';
import moment from 'moment';

import errorHandle from '../utils/errorHandle';
import authContext from '../context/authContext/authContext';
import Loader from '../utils/Loader';
import PortfolioModal from '../components/modals/PortfolioModal';
import DematStatus from '../utils/DematStatus';
import PartnerCounters from '../components/partners/PartnerCounters';
import Achievement from '../components/partners/Achievement';

const GET_REFERRAL_USERS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/user/getReferralUsers";

const Referrals = () => {
  const { id } = useParams();
  const { getConfig } = useContext(authContext);
  const intialState = { loading: false, partner: {} }
  const [state, setCompleteState] = useState(intialState);
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const getReferralUsers = async () => {
    setState({ loading: true })
    const config = getConfig();
    await axios.get(GET_REFERRAL_USERS_API_END_POINT, config)
      .then((res) => {
        const { referralUsers = [], achievements = [] } = res.data
        const dematUsers = referralUsers?.filter((user) => user.clientId && user.dematStatus === 'approved')
        const totalPartnerRewards = referralUsers.reduce((total, user) => total + user.products.reduce((sum, p) => sum + (p.partnerReward || 0), 0), 0);
        const ratingUsers = referralUsers?.filter((user) => user.partnerRating);
        const averageRating = ratingUsers.reduce((sum, user) => sum + user.partnerRating, 0) / ratingUsers.length;

        setState({
          referralUsers: referralUsers,
          dematUsers: dematUsers,
          totalPartnerRewards: totalPartnerRewards,
          averageRating: averageRating,
          achievements: achievements,
          loading: false
        })
      })
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      })
  }

  useEffect(() => {
    getReferralUsers()
  }, [id])

  return (
    <div className='container mt-5 pt-5'>

      <div className='section-title'>
        <p>Partner Referrals</p>

        {!state.referralUsers?.length && (
          <div className='text-center' hidden={state.loading}>No Refered User available</div>
        )}
        <div className='text-center'>
          <Loader isLoading={state.loading} />
        </div>
      </div>

      <div>
        <PartnerCounters
          totalReferred={state.referralUsers?.length || 0}
          totalDemat={state.dematUsers?.length || 0}
          totalPartnerRewards={state.totalPartnerRewards || 0}
          averageRating={state.averageRating || 0}
        />
      </div>

      <div className='row my-4 align-items-center justify-content-center'>
        {state.achievements?.map((achievement, index) => (
          <div className='col-md-2 mb-3 mx-2'>
            <Achievement
              key={index}
              event={achievement.event} achievement={achievement.achievement}
            />
          </div>
        ))}
      </div>

      <div className='mb-5' hidden={!state.referralUsers?.length || state.loading}>
        <div className='card'>
          <div className='card-body' style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table className="table table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">Unique ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Partner</th>
                  <th scope="col">GT</th>
                  <th scope="col">Rewards</th>
                  <th scope="col">Ratings</th>
                  <th scope="col">Created</th>
                  <th scope="col">Demat</th>
                  <th scope="col">Products</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {state?.referralUsers?.map((user, i) => {
                  const { _id, name, email, phone, gdTokens, isPartner, createdAt, dematStatus, clientId, products, partnerRating } = user;
                  const partnerRewards = products?.reduce((total, product) => total + (product.partnerReward || 0), 0);
                  return (
                    <tr key={user._id}>
                      <th>{_id}</th>
                      <td>{name}</td>
                      <td>{email}</td>
                      <td>{phone}</td>
                      <td><DematStatus dematStatus={isPartner} /></td>
                      <td>{gdTokens}</td>
                      <td>{partnerRewards}</td>
                      <td>{partnerRating}</td>
                      <td>
                        <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                        <small className='text-muted'>{moment(createdAt).format("h:mm:ss a")}</small>
                      </td>
                      <td scope="row">
                        <DematStatus dematStatus={dematStatus} />
                        <div className='fs-12'>{clientId}</div>
                      </td>
                      <td>{products.length}</td>
                      <td>
                        <button type='button' className='btn btn-xs' onClick={() => setState({ selectedUser: user, isPortfolioModalOpen: true })} disabled={state.loading || !products?.length}>
                          <i className="fa fa-eye" />
                        </button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PortfolioModal
        isOpen={state.isPortfolioModalOpen}
        toggle={() => setState({ isPortfolioModalOpen: false, selectedUser: null })}
        user={state.selectedUser}
      />
    </div>
  )
}

export default Referrals;